webpackJsonp([82206309271128],{

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/header.64bf72fe.jpg";

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  @media (min-width: 650px) {\n    margin: 0 2.5em;\n  }\n\n  @media (min-width: 850px) {\n    margin: 0 5em;\n  }\n\n  p {\n    font-size: 20px;\n\n    strong {\n      font-weight: 600;\n    }\n  }\n'], ['\n  @media (min-width: 650px) {\n    margin: 0 2.5em;\n  }\n\n  @media (min-width: 850px) {\n    margin: 0 5em;\n  }\n\n  p {\n    font-size: 20px;\n\n    strong {\n      font-weight: 600;\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  @media (min-width: 650px) {\n    margin: 0 -2.5em 3em;\n  }\n\n  @media (min-width: 850px) {\n    margin: 0 -5em 3em;\n  }\n'], ['\n  @media (min-width: 650px) {\n    margin: 0 -2.5em 3em;\n  }\n\n  @media (min-width: 850px) {\n    margin: 0 -5em 3em;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(27);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _header = __webpack_require__(171);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SpeakingPage = _styledComponents2.default.div(_templateObject);
	
	var Pic = _styledComponents2.default.div(_templateObject2);
	
	var Speaking = function (_React$Component) {
	  _inherits(Speaking, _React$Component);
	
	  function Speaking() {
	    _classCallCheck(this, Speaking);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Speaking.prototype.render = function render() {
	    return _react2.default.createElement(
	      SpeakingPage,
	      null,
	      _react2.default.createElement(
	        Pic,
	        null,
	        _react2.default.createElement('img', { src: _header2.default, width: '1700', height: '719', alt: '' })
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Since 2006, I\'ve been regularly giving presentations or workshops on various topics ranging from ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'web accessibility'
	        ),
	        ' and',
	        ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'modern front-end development'
	        ),
	        ', through',
	        ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'working remotely'
	        ),
	        ', to',
	        ' ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'managing distributed teams'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'If you\'d like me to speak at your event, just',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:speaking@wojtekzajac.com' },
	          'get in touch'
	        ),
	        '!'
	      )
	    );
	  };
	
	  return Speaking;
	}(_react2.default.Component);
	
	exports.default = Speaking;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-speaking-js-0e075edfd504341bb6af.js